import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef, NbDialogService } from '@nebular/theme';
import { Categorie } from '../../../shared/data/categorie';
import { plainToClass } from 'class-transformer';
import { Critere } from '../../../shared/data/critere';
import { Config } from '../../../config/config';
import { MediathequeComponent } from '../../../shared/mediatheque/mediatheque.component';

@Component({
  selector: 'ngx-edit-critere',
  templateUrl: './edit-critere.component.html',
  styleUrls: ['./edit-critere.component.scss']
})
export class EditCritereComponent implements OnInit {
  @Input() id: number;
  @Input() typecrit: string;
  /* nome;
  desc;
  cate:any = []; */
  crit = new Critere;
  hideLoader =true;
  hideButon =false;
  // pr;

  titre = 'option';

  config = Config;

  categories: any[];

  constructor(protected dialogRef: NbDialogRef<EditCritereComponent>,private apiService:ApiService, private router:Router,private sendeurService:EventSendeurService, public toastr: NbToastrService, private dialogService: NbDialogService) {
  
    /* if( this.id !== 0 )
    this.getCategories(); */

    

  }

  ngOnInit() {


    this.crit.type_critere = this.typecrit;

    switch(this.typecrit) { 
      case 'cycle': { 
         //statements; 
         this.titre = 'Cycle';
         break; 
      } 
      case 'pays': { 
         //statements; 
         this.titre = 'Pays';
         break; 
      } 
      case 'partner': { 
        //statements; 
        this.titre = 'Partenaire';
        break; 
      } 
      case 'admissibility': { 
        //statements; 
        this.titre = 'Admissibilité';
        break; 
      }
      case 'particularity': { 
        //statements; 
        this.titre = 'Particularité';
        break; 
      }
      case 'type_ecole': { 
        //statements; 
        this.titre = 'Type d\'école';
        break; 
      }
      case 'secteur': { 
        //statements; 
        this.titre = 'Secteur';
        break; 
      }
      case 'catformation': { 
        //statements; 
        this.titre = 'Catégorie';
        break; 
      } 
      case 'niveau': { 
        //statements; 
        this.titre = 'Niveau requis';
        break; 
      }
      case 'daterentree': { 
        //statements; 
        this.titre = 'Date Rentrée';
        break; 
      }
      default: { 
         //statements; 
         break; 
      } 
      case 'secteur_metier': { 
        //statements; 
        this.titre = 'Secteur';
        break; 
      }
      case 'salaire': { 
        //statements; 
        this.titre = 'Salaire';
        break; 
      }
      case 'alternance': { 
        //statements; 
        this.titre = 'Alternance';
        break; 
      }
      case 'selectivite': { 
        //statements; 
        this.titre = 'Selectivité';
        break; 
      }
      case 'insertion': { 
        //statements; 
        this.titre = 'Insertion';
        break; 
      }
      case 'type_contrat': { 
        //statements; 
        this.titre = 'Type de contrat';
        break; 
      }
    } 

    if(this.id !== 0)
    this.getOneCritere();

    this.sendeurService.image.asObservable().subscribe(data =>{

      // this.imageChoisie = this.sanitizer.bypassSecurityTrustResourceUrl(data);

      // console.log(this.imageselect);

        this.crit.photo = data;


    })
   
  }

  cancel(){
    this.dialogRef.close();
    
    
  }

  close(){
    this.dialogRef.close();
    
    
  }

  

  updateCrit(){

    if( this.id !== 0 ) {

      this.hideButon= true;
      this.hideLoader = false;
      this.apiService.updateCritereProvider(this.crit).subscribe((data: Critere) =>{
        console.log(data);
        this.toastr.success("mise à jour réussie","success");
        this.dialogRef.close();
        /* this.sendeurService.sendCategoryEvent(7); */
        this.sendeurService.sendCritereEvent(data);

      },(err) =>{
        console.log(err);
        this.toastr.danger("echec de mise à jour réussie, le nom de cette category existe peut être déjà");
        this.hideButon= false;
        this.hideLoader = true;
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
        
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
        }
    
      })

    } else {


      this.hideLoader = false;
      this.hideButon = true;
      

      this.apiService.addCritereProvider(this.crit).subscribe((data: Critere) =>{
        console.log(data);
        this.toastr.success("Option crée avec success");
        this.dialogRef.close();
        this.sendeurService.sendCritereEvent(data);
        /* this.sendeurService.sendCategoryEvent(5); */
      },(err) =>{
        this.hideLoader = true;
        this.hideButon = false;
        this.toastr.danger("Il se peut qu'une option portant le meme nom existe déjà","erreur");
        console.log(err);
      
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page","echec");
        }
    
    })



    }
    
  }

  getOneCritere(){

    this.apiService.getOneCritereProvider(this.id).subscribe(data =>{

      this.crit = plainToClass(Critere, data as object);

    },(err) =>{
      

      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }


      if(err.error.code ===500){
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }

    })

  }


  typeCritChanged($event){

    this.crit.type_critere = $event;

  }


  addImage(){
    this.dialogService.open(MediathequeComponent, {context: { mime: 'image'}});
  }


}
